import * as api from '../../services/invitationBgm'

export const FETCH_INVITATION_BGMS = 'FETCH_INVITATION_BGMS';
export const FETCH_INVITATION_BGM = 'FETCH_INVITATION_BGM';


export const fetchInvitationBgm = (id) => ({
    type: FETCH_INVITATION_BGM,
    payload: {
        promise: api.findInvitationBgm({id: id})
    }
});


export const fetchInvitationBgms = (params, pagination, sort, extra) => {

    return {
        type: FETCH_INVITATION_BGMS,
        payload: {
            promise: api.findInvitationBgms(Object.assign({}, params)),
        },
        meta: {
            searchParams: params,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/invitationBgm.js